import FullPageLoader from '@/components/FullPageLoader';
import { useOrganizations } from '@/hooks/useOrganizations';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

interface iOrganizationsLoaderProps {}

const OrganizationsLoaderPage: FunctionComponent<iOrganizationsLoaderProps> = () => {
  const { t } = useTranslation('common');
  useOrganizations();
  return <FullPageLoader title={t('orgLoader.title')} subtitle={t('orgLoader.description')} />;
};

export default OrganizationsLoaderPage;
